// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueResource from 'vue-resource'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import { SweetModal } from 'sweet-modal-vue'
import { Portal, Router } from '@/components/portal'
import { Dialog, Row, Col, Input, Button, Select, Option, Table, TableColumn, Pagination, Upload, Carousel, CarouselItem, MessageBox } from 'element-ui'

Vue.use(Dialog)
Vue.use(Row)
Vue.use(Col)
Vue.use(Input)
Vue.use(Button)
Vue.use(Select)
Vue.use(Option)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Pagination)
Vue.use(Upload)
Vue.use(VueResource)
Vue.use(VueAwesomeSwiper)
Vue.use(Carousel)
Vue.use(CarouselItem)
Vue.component('sweet-modal', SweetModal)
Vue.config.productionTip = false
Vue.prototype.$alert = MessageBox.alert

/* eslint-disable no-new */
new Vue({
  el: '#container',
  router: Router,
  template: '<Portal/>',
  components: { Portal }
})



// WEBPACK FOOTER //
// ./src/modules/index/index.js